<template>
  <v-form class="px-3 pb-3">
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        md7
      >
        <v-layout column>
          <v-flex>
            <app-reference
              v-model="releaseOrder.senderAddress"
              label="Адрес погрузки*"
              resource="addresses"
              component-name="Address"
              :rules="[(v) => !!v || '']"
              :outline="true"
              :height-field="44"
              :without-clearable="true"
              :disabled="disabled || isReleaseOrderDisabledToEdit"
              class="my-2"
              @input="senderAddressChange"
            />
          </v-flex>
          <v-flex>
            <app-date-picker
              v-model="releaseOrder.releaseOrderPlan"
              label="Дата отгрузки*"
              :rules="[(v) => !!v || '']"
              :outline="true"
              :height-field="44"
              prepend-icon="event"
              :without-initial-data="isNew ? false : true"
              :disabled="disabled || isReleaseOrderDisabledToEdit"
              class="my-2"
              @input="releaseOrderAtChange"
            />
          </v-flex>
          <v-flex>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                sm9
                md8
              >
                <v-autocomplete
                  v-model="releaseOrderPeriod"
                  label="Время отгрузки*"
                  :rules="[(v) => !!v || '']"
                  :outline="true"
                  height="44"
                  class="my-2"
                  :items="periods"
                  return-object
                  hide-details
                  hide-selected
                  browser-autocomplete="nope"
                  no-filter
                  no-data-text="Данные не выбраны"
                  clear-icon="close"
                  prepend-inner-icon="query_builder"
                  :disabled="disabled || isReleaseOrderDisabledToEdit"
                  @input="releaseOrderPeriodChange"
                />
              </v-flex>
              <v-flex
                xs12
                sm3
                md4
                class="text-xs-center"
              >
                <v-chip
                  slot="activator"
                  text-color="white"
                  label
                  :color="releaseCriteria.color"
                  style="height: 44px; min-width: 130px"
                  class="my-2 mx-1 release-chip"
                >
                  {{ releaseCriteria.title }}
                </v-chip>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            md6
          >
            <v-radio-group
              v-model="releaseOrder.transportType"
              hide-details
              row
              height="25"
              class="ml-2 my-3"
            >
              <v-radio
                v-for="(item, index) in transportTypes"
                :key="index"
                :label="item.text"
                :value="item.value"
                :disabled="disabled || isReleaseOrderDisabledToEdit"
                @change="changeTransportType(index)"
              />
            </v-radio-group>
            <TransportInfo
              v-if="
                releaseOrder.transportType !== eTransportTypes.COURIERSERVICE
              "
              v-model="releaseOrder.transport"
              :is-need-transport="
                releaseOrder.transportType === eTransportTypes.NEEDTRANSPORT
              "
              :disabled="disabled || isReleaseOrderDisabledToEdit"
              @change="transportChange"
            />
            <CourierInfo
              v-if="
                releaseOrder.transportType === eTransportTypes.COURIERSERVICE
              "
              v-model="releaseOrder.courier"
              :disabled="disabled || isReleaseOrderDisabledToEdit"
              :is-courier-type="isCourierType"
              @change="courierChange"
            />
          </v-flex>
          <v-flex
            v-if="isShipping && isNew"
            xs12
            md6
          >
            <v-layout
              row
              wrap
              align-center
            >
              <v-flex
                sx12
                sm4
                md4
              >
                <DecimalEditor
                  v-model="releaseOrder.volume"
                  label="Объем к отгрузке"
                  :outline="true"
                  :height-field="44"
                  :scale="3"
                  class="my-2 ml-2"
                />
              </v-flex>
              <v-flex
                sx12
                sm4
                md4
              >
                <DecimalEditor
                  v-model="releaseOrder.cargoPlaces"
                  label="К-во мест к отгрузке"
                  :outline="true"
                  :height-field="44"
                  class="my-2 ml-2"
                />
              </v-flex>
              <v-flex
                sx12
                sm4
                md4
              >
                <v-switch
                  v-model="releaseOrder.isPartial"
                  :label="
                    releaseOrder.isPartial
                      ? 'Частичная выдача товара'
                      : 'Полная выдача товара'
                  "
                  color="red lighten-1"
                  hide-details
                  class="switch-color my-2 ml-2"
                  :disabled="disabled || isReleaseOrderDisabledToEdit"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            v-if="isShipping && isNew"
            xs12
            md6
          >
            <v-text-field
              v-model="releaseOrder.number"
              label="Номер проформы"
              hide-details
              outline
              height-field="44"
              class="my-2 ml-2"
            />
            <v-text-field
              v-model="releaseOrder.notes"
              label="Комментарии"
              hide-details
              outline
              height-field="44"
              class="my-2 ml-2"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-spacer style="maxwidth: 40px" />
      <v-flex>
        <ArrivalPlaceSelect
          v-if="releaseOrder.transportType !== eTransportTypes.CLIENTTRANSPORT"
          :id="id"
          :disabled="disabled || isReleaseOrderDisabledToEdit"
        />
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import TransportInfo from "./TransportInfo.vue";
import CourierInfo from "./CourierInfo.vue";
import ArrivalPlaceSelect from "./arrival-place/ArrivalPlaceSelect.vue";
import * as releaseOrderPeriodsApi from "../../../backend/releaseOrderPeriodsApi.js";
import * as basErpApi from "../../../backend/basErpApi.js";
import * as ordersApi from "../../../backend/releaseOrdersApi.js";
import { eTransportTypes } from "./transport-types.js";
import DecimalEditor from "../../../components/text-fields/DecimalEditor.vue";

export default {
  components: { TransportInfo, CourierInfo, ArrivalPlaceSelect, DecimalEditor },
  props: ["id", "disabled", "isShipping"],
  data() {
    return {
      isValid: false,
      periods: null,
      needSync: false,
      releaseOrder: null,
    };
  },
  computed: {
    releaseOrderStore() {
      return this.$store.getters["releaseOrders/releaseOrder"];
    },
    shippings() {
      return this.$store.getters["releaseOrders/shippings"];
    },
    releaseCriteria() {
      const shippings = this.shippings;
      const releasedShippings = shippings.some((item) => {
        return item.released === true;
      });
      const notReleasedShippings = shippings.some((item) => {
        return item.released === false;
      });

      if (releasedShippings && notReleasedShippings) {
        return {
          title: "Частично выдано",
          color: "grey",
        };
      } else if (releasedShippings && !notReleasedShippings) {
        return {
          title: "Выдано",
          color: "green",
        };
      } else {
        return {
          title: "Не выдано",
          color: "red",
        };
      }
    },
    isReleaseOrderDisabledToEdit() {
      const shippings = this.shippings;
      const releasedShippings = shippings.some((item) => {
        return item.released === true;
      });
      const notReleasedShippings = shippings.some((item) => {
        return item.released === false;
      });

      return releasedShippings && !notReleasedShippings;
    },
    transportTypes() {
      return this.$store.getters["releaseOrders/transportTypes"];
    },
    releaseOrderPeriod: {
      get() {
        return this.$store.getters["releaseOrders/releaseOrderPeriod"];
      },
      set(period) {
        this.$store.commit("releaseOrders/setReleaseOrderPeriod", period);
      },
    },
    isNew() {
      return +this.id ? false : true;
    },
    eTransportTypes() {
      return eTransportTypes;
    },
    arrivalPlaces() {
      return this.$store.getters["releaseOrders/arrivalPlaces"];
    },
    isCourierType() {
      return (
        this.releaseOrder.transportType === this.eTransportTypes.COURIERSERVICE
      );
    },
    shipping() {
      if (!this.isShipping) {
        return null;
      }
      const shipping = this.$store.getters["shipping/shipping"];
      return {
        cargoPlaces: shipping.CargoPlaces,
        volume: shipping.Volume,
      };
    },
  },
  watch: {
    isValid() {
      this.$emit("validChanged", this.isValid);
    },
    releaseOrder: {
      handler() {
        if (
          this.releaseOrder.senderAddress &&
          this.releaseOrder.releaseOrderPlan &&
          this.releaseOrder.releaseOrderPeriod
        ) {
          return (this.isValid = true);
        } else {
          return (this.isValid = false);
        }
      },
      deep: true,
    },
    arrivalPlaces(value) {
      this.changeArrivalPlaces(value);
    },
    releaseOrderStore: {
      handler(value) {
        if (!value) {
          return;
        } else if (this.isShipping && this.isNew) {
          this.releaseOrder = value;
          this.releaseOrder.volume = this.shipping?.volume || null;
          this.releaseOrder.cargoPlaces = this.shipping?.cargoPlaces || null;
          return;
        }
        this.releaseOrder = value;
      },
      immediate: true,
    },
  },
  created() {
    this.getReleaseOrderPeriod();
  },
  methods: {
    async getReleaseOrderPeriod() {
      const res = await releaseOrderPeriodsApi.getPeriods(
        "release-order-periods"
      );
      this.periods = res.data.map((p) => {
        return {
          value: p.Id,
          text: p.Title,
        };
      });
    },
    async transportChange(value) {
      if (
        JSON.stringify(this.releaseOrder.transport) === JSON.stringify(value)
      ) {
        return;
      }

      if (!this.isNew) {
        try {
          await ordersApi.changeReleaseOrderTransport(
            this.id,
            value.registrationNumber,
            value.driver,
            value.phone
          );
          this.releaseOrder.transport = {
            registrationNumber: value.registrationNumber,
            driver: value.driver,
            phone: value.phone,
          };
          this.showInfo("Информация о транспорте изменена");
          this.$store.commit(
            "releaseOrders/setReleaseOrder",
            this.releaseOrder
          );
        } catch (error) {
          if (error.message) {
            this.showError(error.message);
          } else {
            throw error;
          }
        }
      } else {
        this.releaseOrder.transport = {
          registrationNumber: value.registrationNumber,
          driver: value.driver,
          phone: value.phone,
        };
        this.$store.commit("releaseOrders/setReleaseOrder", this.releaseOrder);
      }
      this.setNeedSync();
    },
    async courierChange(value) {
      if (JSON.stringify(this.releaseOrder.courier) === JSON.stringify(value)) {
        return;
      }

      this.releaseOrder.courier = {
        company: value.company,
        waybillNumber: value.waybillNumber,
      };
      if (this.isNew) {
        return;
      }
      await ordersApi.changeReleaseOrderDeliveryInfo(
        this.id,
        value.company?.id,
        value.waybillNumber
      );
      this.showInfo("Информация о курьере изменена");
      this.$store.commit("releaseOrders/setReleaseOrder", this.releaseOrder);
      this.setNeedSync();
    },
    async releaseOrderPeriodChange(period) {
      this.releaseOrder.releaseOrderPeriod = period
        ? {
          id: period.value,
          title: period.text,
        }
        : null;
      if (this.isNew) {
        return;
      }
      await ordersApi.changeReleaseOrderUnloadPeriod(this.id, period.value);
      this.$store.commit("releaseOrders/setReleaseOrder", this.releaseOrder);
      this.showInfo("Время отгрузки изменено");
      this.setNeedSync();
    },
    async senderAddressChange() {
      const newSenderAddress = this.releaseOrder.senderAddress;
      if (this.isNew || newSenderAddress === null) {
        return;
      }
      await ordersApi.changeSenderAddress(this.id, newSenderAddress.id);
      this.$store.commit("releaseOrders/setReleaseOrder", this.releaseOrder);
      this.showInfo("Адрес погрузки изменен");
      this.setNeedSync();
    },
    async releaseOrderAtChange(newDate) {
      if (this.isNew) {
        return;
      }
      await ordersApi.reschedule(this.id, newDate);
      this.$store.commit("releaseOrders/setReleaseOrder", this.releaseOrder);
      this.showInfo("Дата отгрузки изменена");
      this.setNeedSync();
    },
    async changeTransportType(value) {
      if (this.isNew) {
        return;
      }

      await ordersApi.updateTransportType(this.id, value);
      this.setNeedSync();

      if (value === eTransportTypes.COURIERSERVICE) {
        this.transportChange({
          registrationNumber: null,
          driver: null,
          phone: null,
        });
      } else {
        this.courierChange({ company: null, waybillNumber: null });
      }
    },
    changeArrivalPlaces(value) {
      if (
        JSON.stringify(this.releaseOrder.arrivalPlaces) ===
        JSON.stringify(value)
      ) {
        return;
      }

      this.releaseOrder.arrivalPlaces = this.arrivalPlaces;
    },
    async setNeedSync() {
      this.needSync = await basErpApi.getNeedSync(this.id);
      this.$store.commit("releaseOrders/setNeedSync", this.needSync);
    },
  },
};
</script>
